<template>
  <div class="score-container" :class="{open: show}">
    <div class="mask" @click="modalTaggle">
      <div class="btn">
        <img src="@/assets/img/score.png" alt="">
      </div>
    </div>
    <div class="score-list">
      <div class="score-item" v-for="(item, index) in scoreList" :key="index">
        <p :class="{disabled: item.toprecord_id * 1 === 0 && item.score * 1 === 1}" @click="backSee(item.topic_sort, item.toprecord_id)">{{ item.name }}</p>
        <ul>
          <li :class="{ active: item.score === 0 || item.score === '0.0' }">0分</li>
          <li :class="{ active: item.score == 0.5 }">0.5分</li>
          <li :class="{ active: item.score == 1 }">1分</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ScoreModal",
  props: {
    scoreList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      show: false
    };
  },
  methods: {
    modalTaggle() {
      this.show = !this.show;
    },
    backSee(topic_sort, toprecord_id) {
      if (toprecord_id === 0) return;
      Object.assign(this.$data, this.$options.data())
      this.$router.replace({
        name: 'topic',
        query: {
          topic_sort,
          type: 0,
          ass_num: this.$route.query.ass_num,
          eva_type: this.$route.query.eva_type
        }
      });
    }
  }

}
</script>

<style lang="less" scoped>
.score-container {
  height: 100vh;
  height: 100dvh;
  position: fixed;
  top: 0;
  right: 0;
  z-index: 100;

  .btn {
    width: 0.6rem;
    height: 1.1rem;
    position: absolute;
    right: -0.14rem;
    bottom: 1.3rem;
    transition: all 0.3s;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .score-list {
    width: 2.9rem;
    height: 100%;
    position: absolute;
    top: 0;
    right: -2.9rem;
    background: #fff7ee;
    padding: 0.26rem 0.24rem 0.08rem;
    border-radius: 0.14rem 0 0 0.14rem;
    overflow-y: scroll;
    transition: all 0.3s;
    .score-item {
      width: 100%;
      display: flex;
      align-items: center;
      margin-bottom: 0.14rem;
      p {
        font-size: 0.14rem;
        font-weight: 500;
        color: #ff6536;
        margin: 0;
        width: 0.3rem;
        &.disabled {
          color: #999;
        }
      }
      ul {
        display: flex;
        li {
          width: 0.6rem;
          height: 0.3rem;
          background: linear-gradient(180deg, #fff6e5 0%, #ffebd4 100%);
          border-radius: 0.15rem;
          border: 1px solid #ffc763;
          font-size: 0.13rem;
          color: #630200;
          text-align: center;
          line-height: 0.3rem;
          margin-left: 0.1rem;
        }
        li.active {
          background: linear-gradient(180deg, #ffe56f 0%, #ffd519 100%);
          border: 1px solid #ffbb00;
        }
      }
    }
  }
  &.open {
    width: 100%;
    .mask {
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.5);
      .btn {
        right: 2.76rem;
      }
    }
    .score-list {
      right: 0;
    }
  }
}
</style>